export default "__VITE_ASSET__44f34c0c__"